import { render, staticRenderFns } from "./measurement-filters.vue?vue&type=template&id=24178348&scoped=true"
import script from "./measurement-filters.vue?vue&type=script&lang=js"
export * from "./measurement-filters.vue?vue&type=script&lang=js"
import style0 from "./measurement-filters.vue?vue&type=style&index=0&id=24178348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24178348",
  null
  
)

export default component.exports